var _defs, _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictograms",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#008fd3;}.cls-2,.cls-3,.cls-4{fill:#f0ab00;}.cls-2{opacity:0.7;}.cls-3{opacity:0.4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "281226-pictogram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80,
    y: 56,
    width: 124,
    height: 104
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80,
    y: 82,
    width: 124,
    height: 26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 80,
    y: 108,
    width: 124,
    height: 26
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 80,
    y: 56,
    width: 124,
    height: 26
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204,52V28H20V164H36v32.72L69.81,164H80v20h90.17L204,217.83V184h16V52Zm12,128H200v28.17L171.83,180H84V164H204v-4H68.19L40,187.28V160H24V32H200V52H80v4H216Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.e143ad10be1058b756d40d11b481bfc5.svg";
export { ForwardRef as ReactComponent };